export function HeroBanner({ title, subtitle, right, testId }) {
  return (
    <div
      data-testid={testId || "hero-banner"}
      className="relative overflow-hidden rounded-2xl px-6 py-6 sm:px-8 sm:py-7 mb-6 text-[#1F2937] shadow-md border border-[#22C55E]/15 bg-gradient-to-br from-[#F4FFF7] via-white to-[#F4FFF7]"
    >
      {/* Ambient emerald glow accents – premium light theme */}
      <div className="pointer-events-none absolute -top-24 -right-16 h-72 w-72 rounded-full bg-[#22C55E]/15 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -left-16 h-64 w-64 rounded-full bg-[#22C55E]/10 blur-3xl" />
      <div className="relative flex items-center justify-between gap-4 flex-wrap">
        <div className="min-w-0">
          <h1 className="text-3xl sm:text-4xl font-heading font-black tracking-tight italic text-[#15803D]">
            {title}
          </h1>
          {subtitle && <p className="text-sm sm:text-base text-[#6B7280] mt-1.5 max-w-2xl">{subtitle}</p>}
        </div>
        {right && <div className="shrink-0">{right}</div>}
      </div>
    </div>
  );
}
